// extracted by mini-css-extract-plugin
export default {"container":"LevelInfo_container__R6n6J","header":"LevelInfo_header__0IQyY","leaderboard":"LevelInfo_leaderboard__TevWx"};